import React, { useEffect, useRef, useState } from "react";
import { File } from "../../../../models/File";
import DeleteFileButton from "../../../FileDetailPage/components/DeleteFileButton";

const EvidenceUploadItem: React.FC<{ file: File }> = ({ file }) => {
  return (
    <div
      key={file._id}
      className="flex items-center justify-between p-2 border rounded hover:bg-gray-100 dark:hover:bg-zinc-800"
    >
      <div className="flex flex-col">
        <span className="font-medium truncate">{file.name}</span>
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {file.status}
        </span>
      </div>
      <DeleteFileButton fileId={file._id} onFileDeleted={() => {}} />
    </div>
  );
};

export default EvidenceUploadItem;
